/**
 * Starterset Bestellen – prijscalculator + formulier logica
 */
(function () {
  function formatPrice(num) {
    return num.toLocaleString('nl-NL');
  }

  /* ===== PRODUCT SELECTIE & CONFIG VISIBILITY ===== */
  function initProductSelection() {
    var root = document.querySelector('.starterset[data-section-id]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var configBlock = root.querySelector('#starterset-config-' + sectionId);
    var productRadios = root.querySelectorAll('input[name="Product"]');

    function updateConfig() {
      var selected = root.querySelector('input[name="Product"]:checked');
      var selectedProductType = selected ? selected.getAttribute('data-starterset-product') : null;

      if (configBlock) {
        configBlock.hidden = !selected;
      }

      // Show/hide product-specific set type groups
      if (configBlock) {
        var setTypeGroups = configBlock.querySelectorAll('[data-starterset-settype-for]');
        setTypeGroups.forEach(function (group) {
          var forProducts = group.getAttribute('data-starterset-settype-for').split(',');
          var shouldShow = selectedProductType && forProducts.indexOf(selectedProductType) !== -1;
          group.hidden = !shouldShow;
          // Reset radios in hidden groups to prevent stale submissions
          if (!shouldShow) {
            group.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
              r.checked = false;
            });
          }
        });

        // Set required on first radio of the ACTIVE set type group only
        var allSetTypeRadios = configBlock.querySelectorAll('input[name="Set type"]');
        allSetTypeRadios.forEach(function (r) { r.removeAttribute('required'); });

        if (selected) {
          setTypeGroups.forEach(function (group) {
            if (!group.hidden) {
              var firstRadio = group.querySelector('input[name="Set type"]');
              if (firstRadio) firstRadio.setAttribute('required', '');
            }
          });
        }

        // Set required on shared config fields
        var sharedGroups = ['Lengte', 'Grip dikte'];
        sharedGroups.forEach(function (name) {
          var firstRadio = configBlock.querySelector('input[name="' + name + '"]');
          if (firstRadio) {
            if (selected) {
              firstRadio.setAttribute('required', '');
            } else {
              firstRadio.removeAttribute('required');
            }
          }
        });
      }

      updateTotal();
    }

    productRadios.forEach(function (radio) {
      radio.addEventListener('change', updateConfig);
    });

    updateConfig();
  }

  /* ===== PRIJSCALCULATOR ===== */
  function updateTotal() {
    var root = document.querySelector('.starterset[data-section-id]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var totaalEl = root.querySelector('#starterset-totaal-' + sectionId);
    var totaalWrap = root.querySelector('#starterset-totaal-wrap-' + sectionId);

    var selectedProduct = root.querySelector('input[name="Product"]:checked');
    if (!selectedProduct) {
      if (totaalWrap) totaalWrap.hidden = true;
      return;
    }

    var basePrice = parseInt(selectedProduct.getAttribute('data-starterset-price'), 10) || 0;
    var extras = root.querySelectorAll('[data-starterset-extra]:checked');
    var extrasTotal = 0;
    extras.forEach(function (cb) {
      extrasTotal += parseInt(cb.getAttribute('data-starterset-extra'), 10) || 0;
    });

    var total = basePrice + extrasTotal;

    if (totaalWrap) totaalWrap.hidden = false;
    if (totaalEl) totaalEl.textContent = formatPrice(total);
  }

  /* ===== EXTRA'S CHANGE LISTENER ===== */
  function initExtras() {
    var root = document.querySelector('.starterset[data-section-id]');
    if (!root) return;
    var extras = root.querySelectorAll('[data-starterset-extra]');
    extras.forEach(function (cb) {
      cb.addEventListener('change', updateTotal);
    });
  }

  /* ===== FORM SUBMIT / SUCCESS ===== */
  function initFormSubmit() {
    var root = document.querySelector('.starterset[data-section-id]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var form = root.querySelector('#starterset-form-' + sectionId);
    var successEl = root.querySelector('#starterset-success-' + sectionId);
    if (!successEl) return;

    if (window.location.search.indexOf('success=true') !== -1) {
      if (form) form.style.display = 'none';
      var heading = root.querySelector('#heading-bestellen');
      if (heading) heading.style.display = 'none';
      var levertijdNote = root.querySelector('.starterset__levertijd-note');
      if (levertijdNote) levertijdNote.style.display = 'none';
      successEl.style.display = '';
      setTimeout(function () {
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }
  }

  /* ===== INIT ===== */
  function init() {
    initProductSelection();
    initExtras();
    initFormSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
